import { filterHiddenApps } from "@/common/helpers/filter-hidden-apps";
import { sortAppsByOrder } from "@/common/helpers/sort-apps-by-order";
import { useFilteredNavigation } from "@/common/hooks/use-navigation";
import { ButtonColorVariant, ButtonVariant, buttonVariants } from "@/components/ui/button";
import { userConfigStore } from "@/store/user-config-store";
import { motion } from "framer-motion";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "wouter";
import { ModuleTile } from "./module-tile";

export const ModuleGrid = () => {
  const { t } = useTranslation("home");
  const filteredNavigation = useFilteredNavigation();
  const hiddenAppIds = userConfigStore((state) => state.dashboardHiddenAppIds);
  const order = userConfigStore((state) => state.appOrder);

  const modules = useMemo(() => {
    const orderedApps = sortAppsByOrder(
      filteredNavigation.filter((item) => item.id !== "home"),
      order,
    );
    return filterHiddenApps(orderedApps, hiddenAppIds);
  }, [filteredNavigation, hiddenAppIds, order]);

  return (
    <section className="space-y-2">
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="text-muted-foreground text-xs font-medium tracking-wide uppercase"
      >
        {t("Applications")}
      </motion.h2>
      {modules.length === 0 ? (
        <div className="border-border flex flex-col items-center gap-3 rounded-xl border border-dashed px-6 py-12 text-center">
          <p className="text-muted-foreground text-sm">{t("NoShortcutsPinned")}</p>
          <Link
            to="~/settings"
            className={buttonVariants({ variant: ButtonVariant.Outlined, colorVariant: ButtonColorVariant.Secondary })}
          >
            {t("ManageInSettings")}
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-[repeat(auto-fill,minmax(380px,1fr))] gap-4">
          {modules.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut", delay: (index + 1) * 0.05 }}
            >
              <ModuleTile item={item} />
            </motion.div>
          ))}
        </div>
      )}
    </section>
  );
};
